import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { leakCategories } from "@/mocks/leaks";

const icons: Record<string, string> = {
  film: "ri-movie-2-line",
  variety: "ri-tv-2-line",
  stage: "ri-mic-2-line",
  music: "ri-album-line",
  backstage: "ri-hammer-line",
  brand: "ri-price-tag-3-line",
};

export default function CategoryGrid() {
  return (
    <section className="border-t border-background-200 bg-background-50">
      <div className="wrap py-14 md:py-20">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            index="03"
            eyebrow="Categories"
            title="按线索来源分类"
            desc="六个方向覆盖当前投稿最集中的环节。每条线索只会出现在一个分类下，避免同一件事被反复搬运。"
          />
          <Link
            to="/leaks"
            className="btn-base self-start border border-background-300 px-5 py-2.5 text-foreground-800 hover:border-primary-400 hover:text-primary-600"
          >
            查看全部线索
            <i className="ri-arrow-right-line text-base" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {leakCategories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/leaks?cat=${cat.slug}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-900 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${icons[cat.slug] ?? "ri-file-list-3-line"} text-xl`} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center justify-between gap-2">
                  <span className="font-heading text-base font-bold text-foreground-950">
                    {cat.name}
                  </span>
                  <span className="font-label text-[11px] text-foreground-400">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </span>
                <span className="mt-2 block text-sm leading-relaxed text-foreground-600">
                  {cat.desc}
                </span>
                <span className="mt-3 inline-flex items-center gap-1 font-label text-xs text-primary-600">
                  累计 {cat.count} 条
                  <i className="ri-arrow-right-up-line" />
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}